import { ButtonHTMLAttributes, FC, useMemo } from 'react';

import { ButtonType, mapButtonTypesStyles } from './helpers';
import { ButtonPreloader } from '../ButtonPreloader';
import { ButtonProps, handleLinkWrapping } from '../helpers';

import { ScButton, ScButtonProps } from './styled';

const ButtonComp: FC<ScButtonProps & Pick<ButtonProps, 'buttonType'>> = ({
  children,
  swipeToIcon,
  buttonType,
  blue,
  green,
  neonGreen,
  whiteTransparent,
  grayTransparent,
  lavenderGradient,
  whiteTransparentNoBorder,
  blueTransparent,
  greenTransparent,
  pinkTransparent,
  goldGradient,
  gray,
  darkGray,
  lightGray,
  graphiteGray,
  grayGradient,
  grayDarker,
  ...props
}) => {
  const buttonTypeStyles = useMemo(() => {
    if (green != null) return mapButtonTypesStyles[ButtonType.GREEN];
    if (neonGreen != null) return mapButtonTypesStyles[ButtonType.NEON_GREEN];
    if (goldGradient != null)
      return mapButtonTypesStyles[ButtonType.GOLD_GRADIENT];
    if (blue != null) return mapButtonTypesStyles[ButtonType.BLUE];
    if (gray != null) return mapButtonTypesStyles[ButtonType.GRAY];
    if (darkGray != null) return mapButtonTypesStyles[ButtonType.DARK_GRAY];
    if (lightGray != null) return mapButtonTypesStyles[ButtonType.LIGHT_GRAY];
    if (graphiteGray != null)
      return mapButtonTypesStyles[ButtonType.GRAPHITE_GRAY];
    if (grayGradient != null)
      return mapButtonTypesStyles[ButtonType.GRAY_GRADIENT];
    if (grayDarker != null) return mapButtonTypesStyles[ButtonType.GRAY_DARKER];
    if (whiteTransparent != null)
      return mapButtonTypesStyles[ButtonType.WHITE_TRANSPARENT];
    if (grayTransparent != null)
      return mapButtonTypesStyles[ButtonType.GRAY_TRANSPARENT];
    if (lavenderGradient != null)
      return mapButtonTypesStyles[ButtonType.LAVENDER_GRADIENT];
    if (greenTransparent != null)
      return mapButtonTypesStyles[ButtonType.GREEN_TRANSPARENT];
    if (blueTransparent != null)
      return mapButtonTypesStyles[ButtonType.BLUE_TRANSPARENT];
    if (pinkTransparent != null)
      return mapButtonTypesStyles[ButtonType.PINK_TRANSPARENT];
    if (whiteTransparentNoBorder != null)
      return mapButtonTypesStyles[ButtonType.WHITE_TRANSPARENT_NO_BORDER];
    return mapButtonTypesStyles[ButtonType.TRANSPARENT];
  }, [
    green,
    neonGreen,
    goldGradient,
    blue,
    gray,
    darkGray,
    lightGray,
    graphiteGray,
    grayGradient,
    grayDarker,
    whiteTransparent,
    grayTransparent,
    lavenderGradient,
    greenTransparent,
    blueTransparent,
    pinkTransparent,
    whiteTransparentNoBorder,
  ]);

  return (
    <ScButton type="button" {...props} buttonTypeStyles={buttonTypeStyles}>
      <ButtonPreloader {...props} />
      <div className="btn-bg" />
      <div className="btn-content">
        {swipeToIcon && swipeToIcon.reason ? swipeToIcon.icon : children}
      </div>
    </ScButton>
  );
};

export const Button: FC<
  ButtonProps &
    Omit<ScButtonProps, 'buttonTypeStyles'> & {
      component?: React.ComponentType<ButtonProps>;
    } & ButtonHTMLAttributes<HTMLButtonElement>
> = ({ component, ...rest }) =>
  handleLinkWrapping(component || ButtonComp, rest);
